import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import {
  CustomerDetailStatus,
  CustomerPriceQuoteStatus,
  CustomerStatus,
} from "../types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.customersState || initialState;

export const selectCustomersLoading = createSelector(
  [selectDomain],
  (customersState) => customersState.loading
);

export const selectCustomerDetailLoading = createSelector(
  [selectDomain],
  (customersState) => customersState.detailLoading
);

export const selectCustomersError = createSelector(
  [selectDomain],
  (customersState) => customersState.error
);

export const selectCustomersStatusFilter = createSelector(
  [selectDomain],
  (customersState) => customersState.statusFilter
);

export const selectSelectedCustomerId = createSelector(
  [selectDomain],
  (customersState) => customersState.selectedCustomerId
);

export const selectCustomerDetails = createSelector(
  [selectDomain],
  (customersState) => customersState.customerDetails
);

export const selectCustomerById = (customerId: string) =>
  createSelector([selectDomain], (customersState) => {
    if (
      customersState.customerDetails &&
      String(customersState.customerDetails.customerId) === customerId
    ) {
      return customersState.customerDetails;
    }

    return (
      customersState.list.find(
        (customer) => String(customer.customerId) === customerId
      ) ?? null
    );
  });

export const selectCustomersList = createSelector(
  [selectDomain],
  (customersState) => customersState.list
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (customersState) => customersState.isAddModalOpen
);

export const selectCustomerForm = createSelector(
  [selectDomain],
  (customersState) => customersState.form
);

export const selectCustomerSaving = createSelector(
  [selectDomain],
  (customersState) => customersState.saving
);

export const selectCustomerStatusLabelKey = (status?: string) => {
  const normalized = (status || "").toLowerCase();

  switch (normalized) {
    case CustomerStatus.ACTIVE:
    case "פעיל":
      return "CUSTOMERS.STATUS.ACTIVE";

    case CustomerStatus.INACTIVE:
    case "לא פעיל":
      return "CUSTOMERS.STATUS.INACTIVE";

    default:
      return "CUSTOMERS.STATUS.ACTIVE";
  }
};

export const selectCustomerDetailStatusLabelKey = (status: string) => {
  switch (status.toLowerCase()) {
    case CustomerDetailStatus.DRAFT:
      return "CUSTOMERS.DETAILS.STATUS_VALUES.DRAFT";

    case CustomerDetailStatus.ACTIVE:
      return "CUSTOMERS.DETAILS.STATUS_VALUES.ACTIVE";

    case CustomerDetailStatus.INACTIVE:
      return "CUSTOMERS.DETAILS.STATUS_VALUES.INACTIVE";

    default:
      return "CUSTOMERS.DETAILS.STATUS_VALUES.DRAFT";
  }
};

export const selectCustomerPriceQuoteStatusLabelKey = (
  status: CustomerPriceQuoteStatus
) => {
  switch (status) {
    case CustomerPriceQuoteStatus.DRAFT:
      return "CUSTOMERS.DETAILS.PRICE_QUOTES.STATUS.DRAFT";

    case CustomerPriceQuoteStatus.SENT:
      return "CUSTOMERS.DETAILS.PRICE_QUOTES.STATUS.SENT";

    case CustomerPriceQuoteStatus.ACCEPTED:
      return "CUSTOMERS.DETAILS.PRICE_QUOTES.STATUS.ACCEPTED";

    default:
      return "CUSTOMERS.DETAILS.PRICE_QUOTES.STATUS.DRAFT";
  }
};
